import { render } from "./Identity.vue?vue&type=template&id=9a1eb432&ts=true"
import script from "./Identity.vue?vue&type=script&lang=ts"
export * from "./Identity.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__